import React, {useEffect, useState} from "react";
import tw from "twin.macro";
import {useParams} from "react-router-dom";

import {useAppSelector, useAppDispatch, loadMovie} from '../redux';
import Head from "components/headers/light";
import Footer from "components/Footer";
import UserReviewInputAndList from "components/UserReviewInputAndList.js";
import {SocialShareButton} from "components/SocialShareButton";
import AdComponent from '../components/AdComponent.js';
const Row = tw.div`lg:flex lg:flex-row border-2 min-h-screen pt-8 lg:pt-5 max-w-screen-xl mx-auto `;

const TextColumn = tw.div` bg-gray-800 p-5`;
const Description = tw.text`lg:text-sm text-gray-300 lg:w-64 my-auto my-1`;

const Image = tw.img`h-96 lg:w-72 w-full object-cover bg-blue-200`;
const MainText = tw.div`flex`;
const H1 = tw.text`pt-1 w-48 lg:text-sm text-gray-500`;
const Rating = tw.div`py-5 bg-white w-full flex justify-between `;
const RowColum = tw.div`bg-gray-800 lg:w-72 mt-20`;
const Div = tw.div``;
const MovieContent = tw.div`bg-white px-5 mt-20`;
const Flex = tw.div`flex mx-5 items-center`;
const HeadText = tw.h1`lg:text-2xl md:text-xl text-lg text-gray-900 font-bold py-2`;
const TextContent = tw.h1`text-sm text-gray-800 leading-7 font-semibold py-2`;
const DivRoot = tw.div`w-full  mx-auto px-5 xsm:py-2 lg:py-4 z-50 fixed bg-white`;
const Text = tw.h1`mx-2 text-lg text-gray-800 font-semibold justify-center`;

function TrendingMovieDetails({match}) {

  const id = useParams();

  const dispatch = useAppDispatch();
  const movie = useAppSelector(state => state.movie.movie);

  const movieInfos = movie.filter(item => item.id === id.id);
  const movieInfo = movieInfos[0];

  useEffect(() => {
    if (movie.length <= 0) {
      dispatch(loadMovie());
    }
  }, [dispatch]);



  return (
    <>
      <DivRoot>
        <Head />
      </DivRoot>
      <AdComponent />
      {movieInfo && <div key={movieInfo.id}>
        <Row>
          <RowColum>
            <Image src={movieInfo.cover_url} />
            <TextColumn>
              <Div>
                <MainText>
                  <H1>Movie Name:</H1>
                  <Description>{movieInfo.title}</Description>
                </MainText>
                <MainText>
                  <H1>Genre:</H1>
                  <Description>{movieInfo.genre}</Description>
                </MainText>

                <MainText>
                  <H1>Cast:</H1>
                  <Description>{movieInfo.cast}</Description>
                </MainText>

                <MainText>
                  <H1>Direction:</H1>
                  <Description>{movieInfo.director}</Description>
                </MainText>

                <MainText>
                  <H1>Production:</H1>
                  <Description>{movieInfo.producer}</Description>
                </MainText>

                <MainText>
                  <H1>Music:</H1>
                  <Description>{movieInfo.music_director}</Description>
                </MainText>

                <MainText>
                  <H1>Release Date:</H1>
                  <Description>{movieInfo.release_date}</Description>
                </MainText>
                <MainText>
                  <H1>Rating:</H1>
                  <Description>{movieInfo.rating}</Description>
                </MainText>
                <MainText>
                  <H1>Duration:</H1>
                  <Description>{movieInfo.run_time}</Description>
                </MainText>
                <MainText>
                  <H1>Writer:</H1>
                  <Description>{movieInfo.written_by}</Description>
                </MainText>

              </Div>

            </TextColumn>
          </RowColum>
          <div>
            <MovieContent>
              <HeadText>Synopsis</HeadText>
              <TextContent>{movieInfo.description}</TextContent>
            </MovieContent>
            <hr />
            <Rating>
              {/* <Flex>
                {like ? (
                  <img
                    width="20"
                    onClick={() => LikeCountM()}
                    src={require("../images/flximg/likecolor.svg")}
                  />
                ) : (
                  <img
                    width="20"
                    onClick={() => LikeCountP()}
                    src={require("../images/flximg/like.svg")}
                  />
                )}

                <Text>{movieInfo.like||0}</Text>

              </Flex> */}
              <SocialShareButton />
              {/* <Flex>
                   <Text>Gallery</Text> 
                   <Like>Share</Like> 
                  <a href={"https://www.youtube.com/watch?v=yg-YY8HYzT8"} target="_blank">
                  <ShareLink src={"https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg"} />
                  </a>
                  <ShareLink src={"https://cdnlogo.com/logos/t/96/twitter-icon.svg"} />
                </Flex> */}
            </Rating>
            <hr />
            <UserReviewInputAndList id={id.id} />
          </div>
        </Row>
      </div>}
      {/* ))} */}
      <Footer />

    </>
  );
}

export default TrendingMovieDetails;
